import { useEffect } from 'react';

const DEFAULT_META = {
  title: 'Convertrex - Soluções para gestão e crescimento de Studios',
  description:
    'Convertrex desenvolve soluções para gestão e crescimento de Studios. Conheça o Converlead e o AXYS.',
};

const PAGE_META = {
  '/planos': {
    title: 'Planos Convertrex | Ecossistema para Studios',
    description:
      'Escolha o plano do ecossistema Convertrex. Comece pelo comercial com Converlead e evolua para a operação com AXYS.',
    ogTitle: 'Planos Convertrex — Converlead e AXYS',
  },
};

function setMetaTag(attr, name, content) {
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

const PageMeta = ({ path = '/' }) => {
  useEffect(() => {
    const meta = PAGE_META[path] || DEFAULT_META;
    document.title = meta.title;

    setMetaTag('name', 'description', meta.description);
    setMetaTag('property', 'og:title', meta.ogTitle || meta.title);
    setMetaTag('property', 'og:description', meta.description);
    setMetaTag('property', 'og:url', `https://convertrex.com.br${path === '/' ? '' : path}`);
  }, [path]);

  return null;
};

export default PageMeta;
